import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { isEmpty } from 'lodash';

import Button from 'fuse-ui/components/Button';

const styles = ( theme ) => ( {
    actionBarContainer: {
        display: 'flex',
        height: 52,
        justifyContent: 'flex-end',
    },
    cancelButton: {
        marginRight: theme.spacing.unit * 2,
    },
} );

const DomainManagementBulkActionBar = ( {
    classes,
    domainErrors,
    isLoading,
    onClickCancel,
    disableSaveButton,
    onClickSave
} ) => {
    return (
        <div className={classes.actionBarContainer}>
            {
                !isEmpty( domainErrors ) ? (
                    <Button className={classes.cancelButton}
                        data-automation-id="manage-bulk-side-panel-close"
                        disabled={isLoading}
                        onClick={onClickCancel}>
                    Close
                    </Button>
                ) : (
                    <React.Fragment>
                        <Button className={classes.cancelButton}
                            data-automation-id="manage-bulk-side-panel-cancel"
                            disabled={isLoading}
                            variant="text"
                            onClick={onClickCancel}
                        >
                             Cancel
                        </Button>
                        <Button
                            data-automation-id="manage-bulk-side-panel-save"
                            onClick={onClickSave}
                            disabled={isLoading || disableSaveButton}
                        >
                            Save
                        </Button>
                    </React.Fragment>
                )}
        </div>
    );
};

DomainManagementBulkActionBar.propTypes = {
    classes: PropTypes.object,
    disableSaveButton: PropTypes.bool,
    domainErrors: PropTypes.object,
    isLoading: PropTypes.bool,
    onClickCancel: PropTypes.func,
    onClickSave: PropTypes.func,

};

export default withStyles( styles )( DomainManagementBulkActionBar );
